import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AlertComponent } from '../../alert/alert.component';
import { environment } from 'src/environments/environment';
import { Mgt1Service } from 'src/app/services/mgt1.service';
declare var $: any;
@Component({
  selector: 'app-mgt1list',
  templateUrl: './mgt1list.component.html',
  styleUrls: ['./mgt1list.component.css']
})
export class Mgt1listComponent implements OnInit {

  public environmentSettings: any;

  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  dtOptionsOfMasterDirector: DataTables.Settings = {};
  dtOptionsOfRegisterDirector: DataTables.Settings = {};
  registerMgt1List: any;
  masterDirectorList: any[];
  FromDateModelInMasterDirector: any;
  ToDateModelInMasterDirector: any;
  dtTriggerMasterDirector: Subject<any> = new Subject();
  error: any = { isError: false, errorMessage: '' };
  futureToDate: NgbDateStruct;
  futureFromDate: NgbDateStruct;
  response: boolean;
  nameOfMember: any;
  deleteMgtId: any;
  editParticularId: any;
  doCessationOfMemebership: any;
  doBecomingMember: any;
  isSearchDivVisible = false;

  constructor(private mgt1Service: Mgt1Service, private router: Router, private alert: AlertComponent,
    private route: ActivatedRoute) {
    this.response = false;
  }

  ngOnInit() {

    this.environmentSettings = environment;
    let searchflag = localStorage.getItem('searchdireflag');


    this.dtOptionsOfMasterDirector = {
      destroy: true,
      scrollY: "210px",
      scrollX: true,
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [9] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'MGT-1',
          title: 'MGT-1',
          extend: 'excel',
          exportOptions: {
            columns: [0, 1, 2, 3, 4, 6, 8],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          }

        }
      ]
    };
    this.getRegisterMgt1List();

  }

  
  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }

  addMGT1(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['mgt1', 'add']  } }],
      { relativeTo: this.route.parent });
  }
  // this.directorMasterService.getMasterDirector(filterDate)
  //     .subscribe(masterDirectorList => {
  //       this.masterDirectorList = masterDirectorList.directorList;
  //       this.dtTriggerMasterDirector.next();
  //     });

  getRegisterMgt1List() {
    this.registerMgt1List = [];
    this.mgt1Service.getMgtList({ search: false }).subscribe(registerList => {
      this.registerMgt1List = registerList.data;
      this.dtTriggerMasterDirector.next();
    });
  }

  confirmDelete(id) {
    this.deleteMgtId = id;
    $("#deleteConfirm").modal('toggle');
  }

  deletemgt1detail() {
    this.mgt1Service.deleteDetails(this.deleteMgtId).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        $("#mgt1listTable").DataTable().destroy();
        $("#deleteConfirm").modal('toggle');
        this.getRegisterMgt1List();
      } else {
        this.alert.error(response.message);
        $("#mgt1listTable").DataTable().destroy();
        $("#deleteConfirm").modal('toggle');
      }
    });
  }

  editmgt1details(_id) {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['mgt1', 'edit',_id]  } }],
      { relativeTo: this.route.parent });
    // this.router.navigate(['mgt1/edit/', _id]);
  }

  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }
  doAdvSearch() {
    this.response = true;
    var searchParam =
    {
      "nameOfMember": this.nameOfMember,
      "doCessationOfMemebership": this.setDate(this.doCessationOfMemebership),
      "doBecomingMember": this.setDate(this.doBecomingMember),
      'isSearch': true,
    };
    this.registerMgt1List = [];
    $("#mgt1listTable").DataTable().destroy();
    this.mgt1Service.getMgtList(searchParam).subscribe(registerList => {
      this.response = false;
      this.registerMgt1List = registerList.data;
      this.dtTriggerMasterDirector.next();
    });
  }
  generateOutput() {
    let companyId = JSON.parse(localStorage.getItem('companyDetails')).companyID;
    var object = {
      id: null,
      fromDate: this.doCessationOfMemebership,
      toDate: this.doBecomingMember,
      name: this.nameOfMember
    }
    this.mgt1Service.generateDetailsOfHoldingDocument(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(companyId);
          setTimeout(function () {
            self.downloadPdfDocument(companyId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.mgt1Service.downloadDetailsOfHoldingFile(id, 'Multi');
  }
  downloadPdfDocument(id) {
    this.mgt1Service.downloadDetailsOfHoldingPdfFile(id, 'Multi');
  }

  clearAdvSearch() {
    this.nameOfMember = '';
    this.doCessationOfMemebership='';
    this.doBecomingMember = '';
    $("#mgt1listTable").DataTable().destroy();
    this.getRegisterMgt1List();
    this.response = false;
  }
}